// noinspection SpellCheckingInspection

import Str from "./Str";

/**
 * @property base_url string
 */
export default class Api {
    /**
     *
     * @returns {string}
     */
    getBaseUrl() {
        if (this.base_url !== undefined) {
            return this.base_url;
        }

        return this.base_url = `${new Str().trim(window.location.origin)}/wp-json/wp/v2`;
    }

    /**
     * @param additional_path
     * @returns {string}
     */
    mountPath(additional_path) {
        return `${this.getBaseUrl()}/${new Str().trim(additional_path)}`;
    }

    /**
     * @return {string}
     */
    getSpeakersIndexUrl() {
        return this.mountPath('palestrante');
    }

    /**
     * @return {string}
     */
    getSpeakersShowUrl() {
        return this.mountPath('palestrante');
    }

    /**
     * @return {string}
     */
    getSchedulesIndexUrl() {
        return this.mountPath('palestra');
    }

    /**
     * @return {string}
     */
    getScheduleStages() {
        return this.mountPath('palcos');
    }

    /**
     * @return {string}
     */
    getScheduleTags() {
        return this.mountPath('speech_tag');
    }

    getEventDays() {
        return this.mountPath('palestra');
    }

    mountImageRootPath(image_name) {
        return window.location.origin + `/wp-content/themes/infobase-wp-theme/public/img/${image_name}`;
    }
}
